import { render, staticRenderFns } from "./CreateUpdateSectionPopup.vue?vue&type=template&id=7212b82b"
import script from "./CreateUpdateSectionPopup.vue?vue&type=script&lang=js"
export * from "./CreateUpdateSectionPopup.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateSectionPopup.vue?vue&type=style&index=0&id=7212b82b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports